import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { useListContext } from 'react-admin';

import { Card, CardContent } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { getListAllAPI, getOneAPI } from '../../../services';
import { formatMoeda } from '../../../utils';
import DialogoDeleteResource from '../DialogoDeletar';
import Tabela from './Tabela';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    //borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const CardTotal = ({ label, value, onClick }) => (
  <Card
    style={{
      borderRadius: '20px',
      cursor: 'pointer',
      margin: '10px 0px',
      flex: 1,
    }}
    onClick={onClick}
  >
    <CardContent>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '100%',
          alignItems: 'center',
        }}
      >
        <div>
          <div
            style={{
              fontSize: '17px',
              color: '#a1c3d1',
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {label}
          </div>
          <div style={{ fontSize: '20px', color: 'black', fontWeight: 'bold' }}>
            {formatMoeda(value)}
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose = () => {} }, ref) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [descontos, setDescontos] = useState([]);
    const [descontoAceitavel, setDescontoAceitavel] = useState(0);
    const [userId, setUserId] = useState(0);
    const [username, setUsername] = useState('');

    const listContext = useListContext();
    const { filterValues } = listContext;

    const [carregando, setCarregando] = useState(false);

    const classes = useStyles({ cor: '#009FD4' });

    const refDialogoDeleteResource = useRef(null);

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
    };

    function formatDescontos(descontos, base) {
      const rowsFormat = [];
      for (let i = 0; i < descontos.length; i++) {
        const desc = descontos[i];
        rowsFormat.push({
          id: desc.id,
          funcionario: desc.user.username,
          categoria: desc.categoria.nome,
          data: moment(desc.data).format('DD/MM/YYYY'),
          valor: formatMoeda(desc.valor),
          isAcima: desc.valor >= base,
          valorOriginal: desc.valor,
          gerente: desc.gerente ? desc.gerente.username : '-',
          testemunha: desc.testemunha ? desc.testemunha.username : '-',
        });
      }
      return rowsFormat;
    }

    async function getDataResource(user_id) {
      try {
        const data = await getListAllAPI(
          'descontos_funcionarios',
          ['data', 'desc'],
          {
            user_id,
            periodo2: filterValues.periodo2,
          },
          ['user', 'categoria', 'gerente', 'testemunha'],
        );
        const data2 = await getOneAPI('config', 1, []);
        setDescontoAceitavel(data2.data.desconto_aceitavel_funcionario);
        setDescontos(
          formatDescontos(data.data, data2.data.desconto_aceitavel_funcionario),
        );
        setUserId(user_id);
        setUsername(data.data.length > 0 ? data.data[0].user.username : '');
        setCarregando(false);
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }

    useImperativeHandle(ref, () => ({
      handleOpen(user_id) {
        setCarregando(true);
        getDataResource(user_id);
        setOpen(true);
      },
    }));

    function getTotalAceitavel() {
      let soma = 0;
      for (let i = 0; i < descontos.length; i++) {
        if (descontos[i].isAcima) {
          soma += descontos[i].valorOriginal;
        }
      }
      return soma;
    }

    function getTotal() {
      let soma = 0;
      for (let i = 0; i < descontos.length; i++) {
        soma += descontos[i].valorOriginal;
      }
      return soma;
    }

    const total = getTotal();

    const totalAceitavel = getTotalAceitavel();

    function deleteHundle({ id }) {
      if (refDialogoDeleteResource.current)
        refDialogoDeleteResource.current.handleOpen(id);
    }

    function refresh() {
      getDataResource(userId);
    }

    const meses = {
      1: 'Janeiro',
      2: 'Fevereiro',
      3: 'Março',
      4: 'Abril',
      5: 'Maio',
      6: 'Junho',
      7: 'Julho',
      8: 'Agosto',
      9: 'Setembro',
      10: 'Outubro',
      11: 'Novembro',
      12: 'Dezembro',
    };

    function getData() {
      if (filterValues.periodo2) {
        return `${meses[filterValues.periodo2.mes + 1]} de ${
          filterValues.periodo2.ano
        }`;
      }

      return '';
    }

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullScreen
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: '#009FD4', color: 'white' }}
          >
            {`Descontos - ${username} - ${getData()}`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '0px 36px 20px',
              margin: '0',
            }}
          >
            {carregando ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <div>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <CardTotal
                    label={`Total Aceitavel (soma dos descontos acima do aceitável (${formatMoeda(
                      descontoAceitavel,
                    )}))`}
                    value={totalAceitavel}
                    onClick={() => {}}
                  />
                  <CardTotal label="Total" value={total} onClick={() => {}} />
                </div>
                <Tabela
                  rows={descontos}
                  descontoAceitavel={descontoAceitavel}
                  deleteHundle={deleteHundle}
                />
              </div>
            )}
          </DialogContent>
        </Dialog>
        <DialogoDeleteResource
          ref={refDialogoDeleteResource}
          handleClose={refresh}
        />
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
